import {
    SET_USER_DATA,
    SET_USER_COUNTRY,
    SET_INVOICE_DATA,
    SET_LOGIN_DATA,
    LOG_IN_USER,
    SET_LOCALE,
    SET_INVOICE_NEEDED
} from '../../booking_engine/actions/summaryActions'

import {updateFormData} from '../../booking_engine/helpers'

export const initialState = {
    id: null,
    price: null,
    invoiceNeeded: true,
    user: {
        firstName: '',
        lastName: '',
        country: '',
        street: '',
        streetNumber: '',
        roomNumber: '',
        city: '',
        postalCode: '',
        comments: '',
        tel: '',
        email: '',
        emailConfirm: '',
        consents: [],
        invoice_type: 'individual',
        invoice_country: '',
        invoice_company: '',
        invoice_nip: '',
        invoice_street: '',
        invoice_streetNumber: '',
        invoice_roomNumber: '',
        invoice_city: '',
        invoice_postalCode: '',
    },
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.args,
                }
            }
        case SET_USER_COUNTRY:
            return {
                ...state,
                user: {
                    ...state.user.address,
                    country: action.country
                }
            }
        case SET_INVOICE_DATA:
            const invoiceDataUpdated = updateFormData(state, action, invoice_data)

            return {
                ...state,
                register_form: {
                    ...state.register_form,
                    invoice_data: invoiceDataUpdated
                }
            }
        case SET_INVOICE_NEEDED:
            return {
                ...state,
                invoiceNeeded: !state.invoiceNeeded
            }
        case SET_LOGIN_DATA:
            const {key, value, isRequired, isValid} = action
            const loginFieldUpdated = {key, value, isRequired, isValid}

            const loginFormUpdated = state.login_form.map(field => {
                if (field.key === action.key) return {
                    ...field,
                    ...loginFieldUpdated
                }
                return field
            })

            return {
                ...state,
                login_form: loginFormUpdated
            }
        case LOG_IN_USER:
            const userData = {}
            const comingUserData = action.user

            for (let key in comingUserData) {
                if (key === 'invoiceAddress') {
                    for (let invoiceAddressKey in comingUserData[key]) {
                        if (invoiceAddressKey === 'invoice') continue;
                        userData[`invoice_${invoiceAddressKey}`] = comingUserData[key][invoiceAddressKey]
                    }
                } else {
                    userData[key] = !comingUserData[key] ? '' : comingUserData[key]
                }
            }

            return {
                ...state,
                user: {
                    ...state.user,
                    ...userData,
                    id: action.user.user_id ? action.user.user_id : action.user.id,
                },
            }
        case SET_LOCALE:
            return {
                ...state,
                locale: action.locale
            }
        default:
            return {
                ...state
            }

    }
}
